export default {
  NetConfig: '组网配置',
  CurrentNetPeer: '当前组网对端数',
  TitleTips: '您可在列表对单个网关进行快捷组网管理，图形模式支持批量修改，地图模式可根据地理位置查看组网情况。组网拓扑类型暂不支持修改，如有需要请联系我司运维工程师。\n特别提醒：关闭组网功能，将可能影响关联的策略，导致策略、配置失效 ，请谨慎操作！ 如有疑问，可先咨询我司运维工程师再进行操作。',
  ClickDisconnect: '点击断开',
  ClickClose: '点击关闭',
  ClickOpen: '点击开启',
  DisconnectTips: (name: string) => `确定断开与${name}之间的组网连接？如需修改多处，建议切换至图形页面进行批量修改。`,
  ClickConnect: '点击连接',
  ConnectTips: (name: string) => `确定开启与${name}之间的组网连接？如需修改多处，建议切换至图形页面进行批量修改。`,
  DisableNet: (name: string) =>  `确定关闭${name}的组网功能？\n关闭后将断开与其他网关的全部连接，请确认业务影响后再操作`,
  EnableNet: (name: string) =>  `确定开启${name}的组网功能？\n开启后将按初始配置与其他网关建立连接，如有需要可自行调整`,
  List: '列表',
  Chart: '图形',
  TreeShape: '树形 HUB-SPOKE',
  FullyConnectedMode: '全互联模式 FULL-MESH',
  CustomMode: '自由模式 PARTIAL-MESH',
  NoShowInfo: '不展示网关信息',
  CloseTips: '关闭后将断开与其他网关的全部连接，请确认业务影响',
  LineCantOperate: '当前两端网关未全部开启组网，链路即使开启也无法正常连通',
  EnableNetToast: '组网功能已开启',
  DisableNetToast: '组网功能已关闭',
  EnableLineToast: (name1: string, name2: string) => `${name1}与${name2}的组网连接已开启`,
  DisableLineToast: (name1: string, name2: string) => `${name1}与${name2}的组网连接已关闭`,
  NetLoadingTips: '组网连接修改中',
  SearchPlaceholder: '搜索网关号/分支机构',
  WarningDisconnectTips: (name: string) => `确定断开与${name}之间的组网连接？当前两端网关未全部开启组网，链路即使开启也无法正常连通，开启网关组网后将自动连接。`,
  WarningConnectTips: (name: string) => `确定开启与${name}之间的组网连接？当前两端网关未全部开启组网，链路即使开启也无法正常连通，开启网关组网后将自动连接。`,
  ChartCheckTips: '线路数量过多时，可能影响拓扑展示效果，将限制展示数量（50条），建议您筛选查看。',
  SearchGatewayBranch: '搜索网关分支',
  ShowLine: '展示线路',
  ShowLineDetailText: '点击线路查看详细拓扑',
  DetailTopology: '详细拓扑',
  Details: '详情信息',
  CheckTheDetails: '查看详情',
  CheckAll: '全选',
  PleaseSelectAtLeastOneLine: '请选择至少一条线路',
  ConfirmSaveTips: '确定按照当前展示线路提交修改？',
  AllLines: '全部线路',
  SelectLinesMaxTips: (maxNum: number, curNum: number) => `提示：线路展示最多支持${maxNum}条，当前选择${curNum}条，请手动移除后再提交`,
}
